// test978
(978 && 0);
